import { render, staticRenderFns } from "./expired.vue?vue&type=template&id=4373ba83&"
import script from "./expired.vue?vue&type=script&lang=ts&"
export * from "./expired.vue?vue&type=script&lang=ts&"
import style0 from "./expired.vue?vue&type=style&index=0&id=4373ba83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports